import { DrawerLayout } from '@/components/layouts/DrawerLayout.jsx';
import {useNavigate, useParams} from "react-router-dom";
import {Stack} from "@mui/joy";
import {FormSelect} from "@/components/forms/FormSelect.jsx";
import {newInviteUser, roles, inviteUserSchema} from "@/features/users/schema.jsx";
import {FormButtons} from "@/components/FormButtons.jsx";
import {FormProvider, useForm} from "react-hook-form";
import {FormInput} from "@/components/forms/FormInput.jsx";
import {yupResolver} from "@hookform/resolvers/yup";
import {useCreateInvitationMutation} from "@/features/users/api.js";
import {capitalizeFirstLetter} from "@/utils/strings.js";

export function InviteUserPage() {
  const { householdId} = useParams();
  const navigate = useNavigate();

  const form = useForm({
    defaultValues: newInviteUser(),
    resolver: yupResolver(inviteUserSchema)
  });

  const [inviteUser, inviteResult] = useCreateInvitationMutation();

  async function onSubmit(data) {
    const result = await inviteUser({ householdId, data });
    if (result.error) {
      if (result.error.status === 409) {
        form.setError("email", {message: capitalizeFirstLetter(result.error.data.error)});
      }
    } else {
      navigate(`/h/${householdId}/users`);
    }
  }

  return (
    <DrawerLayout title="Invite User">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Stack
            spacing={4}
            sx={{
              display: 'flex',
              pt: 2,
              pb: 3,
            }}
          >
            <Stack spacing={2}>
              <FormInput name="email" label="Email" />
              <FormSelect name="role" label="Role" options={roles}/>
            </Stack>
          </Stack>
          <FormButtons isSaving={inviteResult.isLoading} />
        </form >
      </FormProvider>
    </DrawerLayout>
  );
}
